// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.localization-icon {
    margin: 8px;
    padding: 8px 10px;
    background-color: #004BA0;
    border-radius: 50px;
    display: flex;
    align-items: center;
    font-size: 18px;
    cursor: pointer;
}

.localization-icon-span {
    color: #FFFFFF;
    margin-left: 4px;
    margin-right: 4px;
    text-transform: uppercase;
}

.localization-icon-selected {
    width: 21px;
    height: 21px;
}

.localization-header-width {
    width: 391px;
    height: 75%;
    max-height: 620px;
    justify-content: center;
}

.localization-header {
    padding: 2px 19px;
    font-size: 16px;
    display: flex;
    background-color: #1976D2;
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 51px;
    align-items: center;
    justify-content: space-between;
}

.localization-body {
    display: block;
    background-color: white;
    align-items: center;
    overflow-y: auto;
    height: 90%;
    border-bottom: 3px solid #f3f2f3;
    justify-content: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.localization-popup-bottom-line {
    width: 92%;
    border-style: ridge;
    border-bottom: 1px;
}

.localization-header-text {
    font-size: 18px;
}

.localization-popup-body {
    background-color: white;

}

.localization-each-option-mobile {
    display: flex;
    cursor: pointer;
    padding: 0 20px;
    height: 22px;
    color: #212121;
    font-size: 16px;
    justify-content: space-between;

}


.localization-button-style {
    padding: 10px 30px;
    background-color: #1976D2;
    border-radius: 30px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(69, 69, 69, 0.25);
}

.localization-button {
    display: flex;
    justify-content: center;
    padding: 6px;
}

.TranslateIcon {
    margin-left: 8px;
    margin-right: 3px;
}

.localization-close-img {
    width: 25px;
    height: 25px;
    margin-top: 5px;
    cursor: pointer;
}

@media screen and (max-width: 600px) {

    .localization-icon {
        display: none;
    }

    .localization-header-width {
        width: 358px;
    }

    .localization-button-style {
        padding: 8px 28px;
    }

    .localization-button {
        padding: 20px;
    }

    .localization-close-img {
        width: 25px;
        height: 25px;
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/builder/css/localization.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,uBAAuB;IACvB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;IACf,8BAA8B;;AAElC;;;AAGA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".localization-icon {\n    margin: 8px;\n    padding: 8px 10px;\n    background-color: #004BA0;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n    cursor: pointer;\n}\n\n.localization-icon-span {\n    color: #FFFFFF;\n    margin-left: 4px;\n    margin-right: 4px;\n    text-transform: uppercase;\n}\n\n.localization-icon-selected {\n    width: 21px;\n    height: 21px;\n}\n\n.localization-header-width {\n    width: 391px;\n    height: 75%;\n    max-height: 620px;\n    justify-content: center;\n}\n\n.localization-header {\n    padding: 2px 19px;\n    font-size: 16px;\n    display: flex;\n    background-color: #1976D2;\n    color: white;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    height: 51px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.localization-body {\n    display: block;\n    background-color: white;\n    align-items: center;\n    overflow-y: auto;\n    height: 90%;\n    border-bottom: 3px solid #f3f2f3;\n    justify-content: center;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.localization-popup-bottom-line {\n    width: 92%;\n    border-style: ridge;\n    border-bottom: 1px;\n}\n\n.localization-header-text {\n    font-size: 18px;\n}\n\n.localization-popup-body {\n    background-color: white;\n\n}\n\n.localization-each-option-mobile {\n    display: flex;\n    cursor: pointer;\n    padding: 0 20px;\n    height: 22px;\n    color: #212121;\n    font-size: 16px;\n    justify-content: space-between;\n\n}\n\n\n.localization-button-style {\n    padding: 10px 30px;\n    background-color: #1976D2;\n    border-radius: 30px;\n    color: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    text-transform: uppercase;\n    cursor: pointer;\n    box-shadow: 0 2px 4px rgba(69, 69, 69, 0.25);\n}\n\n.localization-button {\n    display: flex;\n    justify-content: center;\n    padding: 6px;\n}\n\n.TranslateIcon {\n    margin-left: 8px;\n    margin-right: 3px;\n}\n\n.localization-close-img {\n    width: 25px;\n    height: 25px;\n    margin-top: 5px;\n    cursor: pointer;\n}\n\n@media screen and (max-width: 600px) {\n\n    .localization-icon {\n        display: none;\n    }\n\n    .localization-header-width {\n        width: 358px;\n    }\n\n    .localization-button-style {\n        padding: 8px 28px;\n    }\n\n    .localization-button {\n        padding: 20px;\n    }\n\n    .localization-close-img {\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
